import React, {useEffect, useState} from "react"
import {Alert, Button, Drawer, Form, Input, Select} from "antd"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import {EncheresAPI} from "./api"

// « J'offre cette montée à mon père. »
//
// C'est une coutume, pas une option de confort : on achète souvent un honneur
// pour quelqu'un d'autre — un parent, un malade, la mémoire d'un disparu. La
// promesse reste au nom de celui qui paie ; ce qui change, c'est le nom que le
// gabbaï appelle à la Torah, donc ce qui s'imprime sur sa feuille.
//
// D'où le nom hébraïque et la tribu : ce sont les deux informations dont il a
// besoin pour appeler quelqu'un, et elles n'ont aucune raison d'être celles du
// payeur.
export default function OffrirSheet({ouvert, lot, identifier, lang, onFerme, onOffert}) {
    const [form] = Form.useForm()
    const [envoi, setEnvoi] = useState(false)
    const [erreur, setErreur] = useState(null)

    const beneficiaire = (lot && lot.resultat && lot.resultat.beneficiaire) || null

    useEffect(() => {
        if (!ouvert) return
        setErreur(null)
        form.setFieldsValue({
            nom: (beneficiaire && beneficiaire.nom) || "",
            nomHebreu: (beneficiaire && beneficiaire.nomHebreu) || "",
            tribu: (beneficiaire && beneficiaire.tribu) || null,
            note: (beneficiaire && beneficiaire.note) || "",
        })
    }, [ouvert, lot && lot.id])

    if (!lot) return null

    const enregistrer = async (valeurs) => {
        setEnvoi(true)
        setErreur(null)
        try {
            const res = await EncheresAPI.beneficiaire(identifier, lot.id, valeurs)
            if (!res || res.success === false) {
                setErreur(res && res.error === "NOM_REQUIS"
                    ? t`Indiquez au moins un nom, en français ou en hébreu.`
                    : t`Ce nom n'a pas pu être enregistré. Réessayez.`)
                setEnvoi(false)
                return
            }
            if (onOffert) onOffert()
            if (onFerme) onFerme()
        } catch (_) {
            setErreur(t`Ce nom n'a pas pu être enregistré. Réessayez.`)
        } finally {
            setEnvoi(false)
        }
    }

    return (
        <Drawer
            open={ouvert}
            placement="bottom"
            height="auto"
            onClose={onFerme}
            title={lot.label}
            className="ench-sheet"
        >
            {erreur && <Alert type="warning" showIcon message={erreur} style={{marginBottom: 14}}/>}

            <div className="ench-sheet-actuel">
                <Trans>
                    Indiquez qui doit être appelé à la Torah. Votre engagement reste à votre
                    nom : seul le nom annoncé à l'office change.
                </Trans>
            </div>

            <Form form={form} layout="vertical" requiredMark={false} onFinish={enregistrer}>
                <Form.Item label={t`Nom de la personne`} name="nom">
                    <Input placeholder={t`Ex. : Avraham DAYAN`}/>
                </Form.Item>

                <Form.Item
                    label={t`Nom d'appel à la Torah`}
                    name="nomHebreu"
                    extra={t`C'est ce nom que le gabbaï annoncera.`}
                >
                    <Input placeholder={t`Ex. : Avraham ben Yits'hak`}/>
                </Form.Item>

                <Form.Item label={t`Cohen, Lévi ou Israël`} name="tribu">
                    <Select
                        allowClear
                        placeholder={t`Ne sais pas`}
                        options={[
                            {value: "COHEN", label: t`Cohen`},
                            {value: "LEVI", label: t`Lévi`},
                            {value: "ISRAEL", label: t`Israël`},
                        ]}
                    />
                </Form.Item>

                <Form.Item label={t`À préciser au gabbaï`} name="note">
                    <Input.TextArea
                        rows={2}
                        maxLength={500}
                        placeholder={t`Ex. : pour la guérison de…, à la mémoire de…`}
                    />
                </Form.Item>

                <Button type="primary" size="large" block htmlType="submit" loading={envoi}>
                    <Trans>Enregistrer ce nom</Trans>
                </Button>
            </Form>
        </Drawer>
    )
}
